import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFlag2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFlag2"><Path d="M4.5 21.4999V15.1665M4.5 15.1665V3.55542C9.92658 0.893916 14.0734 6.21692 19.5 3.55542V15.1665C14.0734 17.828 9.92658 12.505 4.5 15.1665Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFlag2;
